import { Component, Inject, AfterViewInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
  selector: 'messageToUser-dialog',
  templateUrl: './messageToUser.dialog.html',
  styleUrls: ['./messageToUser.dialog.css'],
})
export class MessageToUserDialog implements AfterViewInit {

  public _showNoButton: boolean;
  public _isMobile: boolean = false;
  public _message: string;
  public _isVertical: boolean = false; // Add the isVertical flag

  constructor(
    public dialogRef: MatDialogRef<MessageToUserDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, isMobile: boolean } = { message: '', isMobile: false }

  ) {
    this._showNoButton = false;
    if (typeof data.message === 'undefined') {
        console.log('data.message is undef');
        //this._message = data as unknown as string;
    }
    if (typeof data === 'string') {
      this._message = data;
      console.log('data.message is undef');
    }
    else
      this._message = data.message; //.errorMessage;
    this._isMobile = data.isMobile;
  }


  ngAfterViewInit() {
    this.updateOrientation();
    window.addEventListener('resize', this.updateOrientation.bind(this));
  }


  updateOrientation() {
    this._isVertical = window.matchMedia('(orientation: portrait)').matches;

    if (this._isVertical) {
      this.dialogRef.updateSize(this._isMobile ? '350px' : '650px');
    } else {
      this.dialogRef.updateSize(this._isMobile ? '350px' : '650px');
    }
  }


  onSaveClick(): void {
      this.dialogRef.close(true);
  }


  onNoClick(): void {
      this.dialogRef.close(false);
  }

}
